import { COLOR_PALETTES } from '@/workflow/_data/config/fragments/colorPalettes';

const colorPalette = 'beta';

/** 'border' keeps sphere colors for domain meaning and shows activation as a camera-facing contour. */
const sphereHighlightCue: 'color' | 'border' = 'border';

export const PRESENTATION_DEFAULTS = {
    colorPalette,
    colors: COLOR_PALETTES[colorPalette],
    sphereHighlightCue,
} as const;